import { Money } from "@redotech/money";
import { PaymentModel } from "@redotech/redo-return-coverage-common/coverage-calculator/utils/derive-payment-model";
import { Equal, booleanEqual, objectEqual } from "@redotech/util/equal";

export interface Coverage {
  exchange: boolean;
  storeCredit: boolean;
  refund: boolean;
}

export const coverageEqual: Equal<Coverage> = objectEqual({
  exchange: booleanEqual,
  refund: booleanEqual,
  storeCredit: booleanEqual,
});

const paymentModelWeights: { [K in PaymentModel]: number } = {
  customer_paid: 1,
  merchant_paid: 0.9,
};

export function paymentModelMultiplier(paymentModel: PaymentModel) {
  return paymentModelWeights[paymentModel];
}

export function pricePerOrder(
  coverage: Coverage,
  paymentModel: PaymentModel,
  base: Money,
): Money {
  const paymentModelWeight = paymentModelMultiplier(paymentModel);
  return {
    amount: +(+base.amount * paymentModelWeight).toFixed(2),
    currency: base.currency,
  };
}

export const defaultBigcommerceFeeName = "redo_v1:";

export const isBigcommerceFeeName = (name?: string) => {
  return (
    name &&
    (name.startsWith(defaultBigcommerceFeeName) || name.startsWith("redo:v1:"))
  );
};

export const getBigcommerceProductTypeFromFeeName = (name?: string) => {
  if (!name) {
    return "";
  }
  // fee names look like `redo:v1:return,package_protection:515` so we need to drop the prefix and drop the trailing cents at the end
  if (
    name.startsWith(defaultBigcommerceFeeName) ||
    name.startsWith("redo:v1:")
  ) {
    return name.substring(defaultBigcommerceFeeName.length).split(":")[0] ?? "";
  }
  return "";
};

export {
  PaymentModel,
  derivePaymentModel,
} from "@redotech/redo-return-coverage-common/coverage-calculator/utils/derive-payment-model";
